"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initLocal = initLocal;
exports.initMulti = initMulti;
const path = __importStar(require("path"));
const os = __importStar(require("os"));
async function initLocal(input, deps) {
    const localPath = deps.cwd ?? process.cwd();
    const loomDir = path.join(localPath, '.loom');
    if (deps.fs.existsSync(loomDir)) {
        if (!input.force) {
            throw new Error(`Loom already exists at ${localPath}. Use --force to overwrite.`);
        }
        await deps.fs.remove(loomDir);
    }
    deps.fs.ensureDirSync(path.join(localPath, '.loom', 'cache'));
    deps.fs.ensureDirSync(path.join(localPath, '.loom', 'prompts'));
    deps.fs.ensureDirSync(path.join(localPath, '.loom', 'schemas'));
    deps.fs.ensureDirSync(path.join(localPath, 'loom'));
    deps.fs.ensureDirSync(path.join(localPath, 'loom', 'refs'));
    return { path: localPath };
}
async function initMulti(input, deps) {
    const defaultPath = path.join(os.homedir(), 'looms', 'default');
    if (deps.fs.existsSync(defaultPath)) {
        if (!input.force) {
            throw new Error(`Loom already exists at ${defaultPath}. Use --force to overwrite.`);
        }
        await deps.fs.remove(defaultPath);
    }
    deps.fs.ensureDirSync(path.join(defaultPath, '.loom', 'cache'));
    deps.fs.ensureDirSync(path.join(defaultPath, '.loom', 'prompts'));
    deps.fs.ensureDirSync(path.join(defaultPath, '.loom', 'schemas'));
    deps.fs.ensureDirSync(path.join(defaultPath, 'loom'));
    deps.fs.ensureDirSync(path.join(defaultPath, 'loom', 'refs'));
    deps.registry.cleanup();
    try {
        deps.registry.addLoom('default', defaultPath);
    }
    catch (e) {
        if (!e.message.includes('already exists'))
            throw e;
    }
    deps.registry.setActiveLoom('default');
    return { path: defaultPath, name: 'default' };
}
